import React, { useEffect, useRef } from 'react';
import './Banner.css';
import fhfLogo from '../../../images/fhf_logo.png';

export default function Banner() {
    const bannerRef = useRef(null);

    useEffect(() => {
        const updateBannerHeight = () => {
            if (bannerRef.current) {
                const height = bannerRef.current.offsetHeight;
                document.documentElement.style.setProperty('--banner-height', `${height}px`);
            }
        };

        // Initial height calculation
        updateBannerHeight();

        // Update height on window resize
        window.addEventListener('resize', updateBannerHeight);

        // Cleanup
        return () => {
            window.removeEventListener('resize', updateBannerHeight);
        };
    }, []);

    return (
        <div className="main_banner" ref={bannerRef}>
            <div id="banner_title">HOUSING POLICY FINDER</div>

            <div id="banner_logo">
                <a target="_blank" rel="noopener noreferrer" href="https://www.fhfund.org/">
                    <img src={fhfLogo} alt="FHF Logo" width="500" id="fhf_logo"/>
                </a>
            </div>

            <div id="banner_intro">The Twin Cities Housing Policy Finder tracks local housing affordability and preservation policies throughout the region. Use the tools below to search by geography or policy type, or explore the map to find more information: Click on any part of a <banner_intro style={{ color: "#33C8BC" }}><b>city</b></banner_intro>, or on a <banner_intro style={{ color: "#e3803f" }}><b> county label</b></banner_intro>,  to learn more about that community's affordable housing policies. <br/> <i>Please Note: Information in this tool is provided on a voluntary basis by participating local jurisdictions. Not all metro counties and cities have provided policy information, and data may be incomplete. </i>
            </div>
        </div>
    );
}

/*   <div id="banner_intro">The Twin Cities Housing Policy Finder tracks local housing affordability and preservation policies throughout the region. 
Use the Zoom and Filter tools below to search by geography or policy type, or explore the map to find more information. 
Click on any part of a <banner_intro style={{ color: "#33C8BC" }}><b>city</b></banner_intro>, or on an <banner_intro style={{ color: "#e3803f" }}><b>orange county boundary</b></banner_intro>, to learn more about that community's affordable housing policies. 
*/